import * as ActionTypes from "./types";

export function deleteScoreRecord(payload) {
    return {
        type: ActionTypes.DELETE_SCORE_RECORD,
        payload: payload
    }
}

export function deleteScoreRecordSuccess(payload) {
  return {
    type: ActionTypes.DELETE_SCORE_RECORD_SUCCESS,
    payload: payload
  }
}

export function deleteScoreRecordFailed(payload) {
  return {
    type: ActionTypes.DELETE_SCORE_RECORD_FAILED,
    payload: payload
  }
}

export function changeScoreRecordState(payload) {
    return {
        type: ActionTypes.CHANGE_SCORE_RECORD_STATE,
        payload: payload
    }
}

export function openUploadModal(payload) {
    return {
        type: ActionTypes.OPEN_UPLOAD_MODAL,
        payload: payload
    }
}

export function closeUploadModal(payload) {
    return {
        type: ActionTypes.CLOSE_UPLOAD_MODAL,
        payload: payload
    }
}

export function createScoreRecordFromFile(payload) {
    return {
        type: ActionTypes.CREATE_SCORE_RECORD_FROM_FILE,
        payload: payload
    }
}

export function createScoreRecordFromFileSuccess(payload) {
  return {
    type: ActionTypes.CREATE_SCORE_RECORD_FROM_FILE_SUCCESS,
    payload: payload
  }
}

export function createScoreRecordFromFileFailed(payload) {
  return {
    type: ActionTypes.CREATE_SCORE_RECORD_FROM_FILE_FAILED,
    payload: payload
  }
}

export function updateScoreRecord(payload) {
  return {
    type: ActionTypes.UPDATE_SCORE_RECORD,
    payload: payload
  }
}

export function updateScoreRecordSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_SCORE_RECORD_SUCCESS,
    payload: payload
  }
}

export function updateScoreRecordFailed(payload) {
  return {
    type: ActionTypes.UPDATE_SCORE_RECORD_FAILED,
    payload: payload
  }
}

export function getScoreRecordById(payload) {
    return {
        type: ActionTypes.GET_SCORE_RECORD_BY_ID,
        payload: payload
    }
}

export function getScoreRecordByIdSuccess(payload) {
  return {
    type: ActionTypes.GET_SCORE_RECORD_BY_ID_SUCCESS,
    payload: payload
  }
}


export function getScoreRecordByIdFailed(payload) {
  return {
    type: ActionTypes.GET_SCORE_RECORD_BY_ID_FAILED,
    payload: payload
  }
}


export function createScoreRecord(payload) {
  return {
    type: ActionTypes.CREATE_SCORE_RECORD,
    payload: payload
  }
}

export function createScoreRecordSuccess(payload) {
  return {
    type: ActionTypes.CREATE_SCORE_RECORD_SUCCESS,
    payload: payload
  }
}

export function createScoreRecordFailed(payload) {
  return {
    type: ActionTypes.CREATE_SCORE_RECORD_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/scoreRecord.js